import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const StepperModalHeader = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  margin-bottom: 20px;
`;

export const SectionDescription = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  font-weight: 600;
`;

export const SectionSubDescription = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
`;

export const StyledText = styled.div`
  margin-bottom: 20px;
`;
